import styled from 'styled-components';

export const Label = styled.p`
  color: ${(props) => props.theme.colors['neutral-100']};
  font-size: 14px;
  line-height: 150%;
  margin-bottom: 12px;
`;

export const FieldWrapper = styled.div`
  margin-top: 8px;
`;
